<template>

    <div class="aichat">
        <!-- 顶部标题栏 -->
        <van-nav-bar title="智价云丨AI 物流报价">
            <template #left>
                <van-icon name="wap-nav" size="28" color="#24272d" @click="openLeftWin" />
            </template>

            <!-- <template #right>
                <van-icon name="search" size="18" />
            </template> -->
        </van-nav-bar>

        <!-- 聊天窗口 -->
        <div class="chatbox">
            <div class="titlelog" v-if="historical.length == 0">
                <van-image round :src="require('@/assets/chatlogo.jpg')" width="10rem" height="10rem"></van-image>
                <h3>智价云 物流 AI 报价系统</h3>
                <h6>集成 DeepSeek-V3 大模型 AI 智能报价系统</h6>
            </div>

            <!-- 单独的聊天记录 -->
            <div v-for="(item, index) in historical" :key="index"
                :class="['message-item', item.role === 'user' ? 'from-user' : 'from-ai']">

                <!-- 加载窗口 -->
                <div v-if="item.content == ''" class="message-load">
                    <van-loading size="28px">加载中...</van-loading>
                </div>

                <!-- 文本展示 -->
                <!-- <div v-else class="message-text" v-html="item.content" ></div> -->
                <div v-else class="message-text" v-html="md.render(item.content)"></div>
                <!-- <VueMarkdown :source="item.content" /> -->
            </div>

        </div>
        <!-- 操作烂 -->
        <div class="chatoption">

            <div class="inputbox">

                <!-- 输入框 -->
                <div class="input">
                    <van-field v-model="message" placeholder="给 智价云 AI 发送消息...." autofocus />
                </div>
                <!-- 按钮 -->
                <div class="button">
                    <van-button icon="upgrade" type="primary" color="#6aa1fb" :disabled="message == ''"
                        @click="sendMessage" :loading="isStream" />
                </div>
            </div>

        </div>


        <!-- 弹窗 -->
        <van-popup v-model="isPopup" position="left" :style="{ width: '50%', height: '100%' }">
            <div class="popupbox">
                <van-image round :src="require('@/assets/chatlogo.jpg')" width="5rem" height="5rem"></van-image>
                <h1>智价云</h1>
                <h4>物流 AI 报价系统</h4>
                <h5>v1.1.1</h5>

                <h5 style="margin-top: auto;">客服热线：18186120010</h5>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { PostMsgStreamCopy, PostMsg } from '../../constant.js'
import MarkdownIt from "markdown-it";
// import VueMarkdown from 'vue-markdown'

export default {
    components: {
        // VueMarkdown,
    },
    data() {
        return {
            isPopup: false, // 左侧弹窗
            isStream: true,// 加载中
            message: '', // 用户消息
            // 对话记录
            historical: [
                // { "role": "user", "content": "你好" },
                // { "role": "assistant", "content": "你好！请问您需要物流报价吗？请提供货物的重量、体积、起运地和目的地等信息，我将为您提供详细的运费报价。方便投｜线上货运险为您的货物保驾护航！" },
                // { "role": "user", "content": "帮我写一个物流的招标书，沈阳到浙江的，大概 300 字" },
                // { "role": "assistant", "content": "很抱歉，我只能提供物流相关的报价服务。如果您需要从沈阳到浙江的物流报价，请提供货物的重量、体积等具体信息，我将为您计算运费。方便投｜线上货运险为您的货物保驾护航！" },
                // { "role": "user", "content": "你除了报价还能干什么呢" },
                // { "role": "assistant", "content": "我主要负责物流报价服务，具体包括：根据货物重量、体积、起运地和目的地计算运费提供详细的运费构成（干线费、中转费、送货费）回答与物流报价相关的咨询如果您需要其他非物流相关的服务，我可能无法提供帮助。请问您需要从沈阳到浙江的物流报价吗？方便投｜线上货运险为您的货物保驾护航" },
                // { "role": "user", "content": "请将你的知识库做成表格的形式" },
                // { "role": "assistant", "content": "很抱歉，我无法将知识库以表格形式呈现。我的主要功能是根据用户提供的物流信息进行精准报价，包括干线费、中转费和送货费的计算。如果您需要物流报价，请提供以下信息：货物重量货物体积起运地目的地我将为您提供详细的运费构成和总价。方便投｜线上货运险为您的货物保驾护航！" },
                // { "role": "user", "content": "请将你的知识库做成表格的形式" },
                // {"role": "assistant", "content": ""},
            ],
            // md:null, // MarkdownIt 工具
        }
    },
    mounted() {
        document.title = this.$route.meta.title || "智价云";
        this.changeFavicon(require('@/assets/智价云 logo.jpg'));
        document.body.style.overflow = 'hidden'; // 禁止滚动

        // MarkdownIt
        this.md = new MarkdownIt({
            html: true,        // 允许 HTML 标签
            linkify: true,     // 自动识别链接
            typographer: true  // 启用排版增强
        })

        // 获取数据内容
        PostMsg('/DeepSeekMes/obtainLines').then(res => {
            // console.log('获取线路信息:', res);
            if (res.data.state == '200') { // 请求成功
                const { lineList, tips } = res.data.data
                const tipMap = []
                // 遍历其他的提示词
                for (const tip of tips) {
                    tipMap.push({
                        role: 'system',
                        content: tip.tip
                    })
                }
                // 线路信息
                for (const line of lineList) {
                    tipMap.push({
                        role: 'system',
                        content: line.datas
                    })
                }

                this.tipList = tipMap
                this.isStream = false
            }
        })
    },
    methods: {
        // 发送消息
        sendMessage() {
            // 判断是否存在历史记录，不存在则新增提示词
            this.sendMsg() // 推送消息
        },
        // 推送消息
        sendMsg() {

            // 合并历史记录-新的消息
            const messageList=this.tipList.concat(this.historical)


            // 添加 历史记录内容
            this.historical.push({
                role: 'user',
                content: this.message
            })

            // 添加到消息队列中
            messageList.push({
                role: 'user',
                content: this.message
            })

            this.message = null // 清空消息

            this.isStream = true

            PostMsgStreamCopy('/DeepSeekMes/messagePush', messageList, (message, textChunk) => {
                
                console.log('数据：', textChunk);

                switch (textChunk) {
                    case '[DONE]':
                        console.log('回复完成');
                        this.isStream = false
                        console.log(this.historical);
                        
                        break;

                    case '[ERROR]':
                        console.log('回复错误');
                        this.$message.error('哎呀～程序错误啦！');
                        // 修改状态
                        this.isError = true
                        // 删除最后一个数据
                        this.historical.pop()
                        break;
                    default:
                        // 转换成 marked 模式 MarkdownIt
                        this.historical[this.historical.length - 1].content = message
                        break;
                }

            })
            // 添加系统回答
            this.historical.push({
                role: 'assistant',
                content: ''
            })
        },
        // 左侧弹窗
        openLeftWin() {
            this.isPopup = true
        },
        // 修改图标
        changeFavicon(url) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = url;
        }
    }
}
</script>

<style lang="less" scoped>
.aichat {
    position: relative;
    height: 100vh;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    // font-size: 24px;

    .chatbox {
        // border: 1px solid red;
        // width: 100%;
        position: relative;
        flex: 1;
        overflow: scroll;
        margin: 0px 5px;
        display: flex;
        flex-direction: column;

        .titlelog {
            position: absolute;
            top: 10px;
            right: 10px;
            bottom: 10px;
            left: 10px;
            // border: 1px solid red;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

        }

        .message-item {
            width: 100%;
            // min-height: 40px;
            // border: 1px solid red;
            // min-width: 80%;
            // width: auto;
            border-radius: 10px;
            font-size: 20px;

            .message-text {
                padding: 10px;
            }
        }

        .from-user {
            width: auto;
            max-width: 80%;
            align-self: flex-end;
            background-color: #c9dcfa;
            // background-color: #6aa1fb;
            color: #333;
        }

        .from-ai {
            width: 100%;
            align-self: flex-start;
            // background-color: #f3c6c6;
            color: #333;
        }
    }

    .chatoption {
        // border: 1px solid red;
        height: 100px;
        display: flex;
        // align-items: center;
        justify-content: center;

        .inputbox {
            // border: 1px solid red;
            width: 95%;
            height: 60px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            margin-top: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .input {
                flex: 1;
            }

            .button {
                margin-right: 5px;
            }

        }
    }

    .popupbox {
        // border: 1px solid red;
        position: absolute;
        top: 10px;
        right: 10px;
        bottom: 10px;
        left: 10px;

        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>